import Dropzone from 'dropzone'

Dropzone.confirm = (question, onConfirm, _rejected) =>
  window.sfConfirm({ question, onConfirm })

// TODO: i18n messages from dropzone
